import Script from 'next/script';

import { CryptoUtils } from '../../domain/auth/crypto.utils';
import { useCore } from '../../feature/context/core.context';
import { useSharedFeatureFlags } from '../../feature/shared-feature-flags/shared-feature-flags.context';
import { useUserLocale } from '../../util/locales/use-user-locale';
import { getLocale } from '../../util/locales/locales';

export const CookieConsent = () => {
  const {
    auth: { user },
  } = useCore();
  const { 'google-analytics': flagEnabled } = useSharedFeatureFlags();
  const locale = useUserLocale() || getLocale();

  const scriptDomain = process.env.NEXT_PUBLIC_COOKIE_CONSENT_SCRIPT_DOMAIN;
  if (!scriptDomain) {
    throw new Error('Missing environment variable NEXT_PUBLIC_COOKIE_CONSENT_SCRIPT_DOMAIN');
  }
  const sharedLDClientId = process.env.NEXT_PUBLIC_LAUNCHDARKLY_SHARED_CLIENT_SIDE_ID;
  if (!sharedLDClientId) {
    throw new Error('Missing environment variable NEXT_PUBLIC_LAUNCHDARKLY_SHARED_CLIENT_SIDE_ID');
  }
  const gaEnvironmentId = process.env.NEXT_PUBLIC_GA_ENVIRONMENT_ID;
  if (!gaEnvironmentId) {
    throw new Error('Missing environment variable NEXT_PUBLIC_GA_ENVIRONMENT_ID');
  }
  const isTestingEnv = process.env.CI === 'true';
  const isGoogleAnalyticsDisabled = !flagEnabled || isTestingEnv;
  const isUserIdentified = user?.anonymousId && user.anonymousId !== 'anonymous';
  const pagePool = process.env.NEXT_PUBLIC_GA_PAGE_POOL ?? 'stihl';
  const pageArea = process.env.NEXT_PUBLIC_GA_PAGE_AREA;

  if (!isGoogleAnalyticsDisabled) {
    return (
      <>
        <Script
          src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
          data-domain-script={scriptDomain}
          data-document-language={true}
        />
        {/* eslint-disable react/no-danger */}
        <Script
          dangerouslySetInnerHTML={{
            __html:
              "function OptanonWrapper() { dataLayer.push({event:'OptanonUpdate'}); window.dispatchEvent(new CustomEvent('consentUpdated')); }",
          }}
        />
        <Script
          dangerouslySetInnerHTML={{
            __html: `window.dataLayer=window.dataLayer||[];window.dataLayer.push({
        'environment_id':'${gaEnvironmentId}',
        'page_pool': '${pagePool}',
        'page_area': '${pageArea}',
        'page_country':'${locale.country}',
        'page_language':'${locale.language}',
        'visitor_login_state':'${isUserIdentified ? 'true' : 'false'}',
        ${
          isUserIdentified
            ? `'user_id': '${CryptoUtils.hashSha256(user.email?.trim().toLowerCase())}', 'stihl_id': '${user.anonymousId}'`
            : ''
        }
        });`,
          }}
        />
        <Script
          dangerouslySetInnerHTML={{
            __html:
              "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://sgtm.stihl.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-MB6KM4TN');",
          }}
        />
        {/* eslint-enable react/no-danger */}
      </>
    );
  }
};
